import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { api } from '@consts/url.const';


@Injectable({
  providedIn: 'root',
})

export class NotificationService {

  constructor(private http: HttpClient) {
  }

  public schedule(data: {
    notificationId: string;
    timeZone: string;
    schedule: string;
  }): Observable<any> {
    return this.http.post(api.notification.schedule, data);
  }

  public subscribeToWebPushNotifications(sub: PushSubscription) {
    return this.http.post(api.device.registerWeb, sub);
  }
}
